import ContentRewardEdit from './ContentRewardEdit';

export default {
  edit: ContentRewardEdit,
};
